import { IconName, Icons, Typography, WuiColor } from '@sonnen/web-ui';
import clsx from 'clsx';
import { createElement, PropsWithChildren } from 'react';
import styles from './InfoBanner.module.css';

export const wuiIconSizes = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'] as const;
export type WuiIconSize = (typeof wuiIconSizes)[number];

type TypographyVariant = keyof typeof Typography;

type TextInfoProps = {
  variant?: 'primary' | 'secondary' | 'destructive' | 'success';
  icon?: IconName;
  iconSize?: WuiIconSize;
  iconFilled?: boolean;
  iconColor?: WuiColor;
  typography?: TypographyVariant;
};

export const InfoBanner = ({
  children,
  variant = 'primary',
  icon = 'Info',
  iconSize = 'lg',
  iconFilled,
  iconColor,
  typography = 'Body2',
}: TextInfoProps & PropsWithChildren) => {
  const TypographyComponent = Typography[typography];

  // Map InfoBanner variants to typography variants
  const typographyVariant = variant === 'destructive' ? 'alert' : 'primary';
  const typographyVariantOverride = variant === 'secondary' ? 'secondary' : typographyVariant;

  return (
    <div className={clsx(styles.infoBanner, styles[variant])} data-testid="info-banner">
      <div className={styles.iconWrapper}>
        {icon &&
          createElement(Icons[icon], {
            size: iconSize,
            filled: iconFilled,
            color: iconColor,
          })}
      </div>
      <TypographyComponent variant={typographyVariantOverride}>{children}</TypographyComponent>
    </div>
  );
};
